module.exports = __webpack_public_path__ + "static/media/recomendation-success.622fa8c1.svg";